import { Messages } from './../utils/messages';
import { Component, OnInit } from '@angular/core';
import { GoogleAnalyticsService } from '../google-analytics-service';

@Component({
  selector: 'app-dom-storage-disabled',
  templateUrl: './dom-storage-disabled.component.html',
  styleUrls: ['./dom-storage-disabled.component.scss']
})
export class DomStorageDisabledComponent implements OnInit {

  message: Messages;
  active = -1;

  title = "Please enable Web Storage in your browser";

  constructor(public window: Window, private googleAnalyticsService: GoogleAnalyticsService) {
    this.message = Messages['en-DE'];
   }

  ngOnInit(): void {
    this.googleAnalyticsService.sendPageView('Dom Storage Disabled', '/authenticate/dom-storage-disabled');
  }

  isActive(index: number) {
    return this.active === index;
  }

  setActive(index: number) {
    if (this.isActive(index)) {
      this.active = -1
    } else {
      this.active = index;
    }
  }

}
